import { render, staticRenderFns } from "./TerminalDeliveryPortal.vue?vue&type=template&id=19a4b3c6&scoped=true&"
import script from "./TerminalDeliveryPortal.vue?vue&type=script&lang=js&"
export * from "./TerminalDeliveryPortal.vue?vue&type=script&lang=js&"
import style0 from "./TerminalDeliveryPortal.vue?vue&type=style&index=0&id=19a4b3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4b3c6",
  null
  
)

export default component.exports